
import React, { createContext, useReducer, useCallback } from 'react';
import languages from '../lists/languages.json'
const path = window.location.pathname
const lastIndex = path.lastIndexOf('/');
const initialLang = path.slice(-3).length >= 3 && path.charAt(0) === '/' ? path.slice(lastIndex + 1) : ''

const GlobalContext = createContext();

const initialState = {
    language: languages.map(({ value }) => value).includes(initialLang.toLocaleLowerCase()) ? initialLang : 'pt-br',
};

const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_LANGUAGE':
            return { ...state, language: action.payload };
        default:
            return state;
    }
};

const GlobalProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const updateLanguage = useCallback((lang) => {
        dispatch({ type: 'UPDATE_LANGUAGE', payload: lang });
    }, []);

    return (
        <GlobalContext.Provider value={{
            state,
            updateLanguage,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};

export { GlobalContext, GlobalProvider };
